import React, { forwardRef } from 'react';
import { Typography } from '../../../atoms/typography/Typography';
import { cnMerge } from '../../../../utils/utils';

const CompareHeaderSection = forwardRef(
  ({ label, title, subTitle, className }, ref) => (
    <div
      ref={ref}
      className={cnMerge(
        'flex flex flex-1 justify-between lg:p-3 lg:pb-4 lg:pt-10 flex-col lg:flex-row gap-5 z-10 bg-primary-50',
        className
      )}
    >
      <div className="flex flex flex-1 flex-col gap-1" />
      <div className="flex flex flex-1 flex-col break-keep overflow-x-visible">
        {label && (
          <Typography
            as="p"
            fontVariant="h8"
            textAlign="left"
            className="!text-customGray-500"
          >
            {label}
          </Typography>
        )}
        <Typography as="h2" fontVariant="h6" textAlign="left">
          {title}
        </Typography>
        {subTitle && (
          <Typography as="h3" fontVariant="lg" textAlign="left">
            {subTitle}
          </Typography>
        )}
      </div>
      <div className="flex flex flex-1 flex-col" />
    </div>
  )
);

export default CompareHeaderSection;
